<template>
	<v-autocomplete
		v-model="internalModel"
		:required="required"
		:label="`${label}${required ? ' *' : ''}`"
		:rules="getRules"
		:error="internalError"
		:items="internalitems"
		v-on="$listeners"
		v-bind="allProps"
  		autocomplete="null"
	></v-autocomplete>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},
		value: {
			type: [String, Number],
			required: false
		},
		items: {
			type: Array,
			required: false
		},
		rules: {
			type: Array,
			default: () => {
				return [];
			}
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			internalError: false,
			requiredMessage: this.$t('requiredMessage')
		};
	},
	computed: {
		internalModel: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit('input', newValue);
			}
		},
		allProps() {
			const propsWithoutLabel = { ...this.$props };
			delete propsWithoutLabel.label;
			return { ...this.$attrs, ...propsWithoutLabel };
		},
		getRules() {
			let rules = [...this.rules];
			if (this.required) {
				const func = (value) => !!value || this.requiredMessage;
				const func2 = () => !this.internalError;
				const func3 = () => {
					return this.internalModel === '' || this.internalModel === null ? this.requiredMessage : true;
				};
				rules = [...rules, func, func2, func3];
			}

			return rules;
		},
		internalitems() {
			return this.items;
		}
	},
	mounted() {}
};
</script>

<style></style>
